"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.syntheticProcess = exports.removeLenderApprovalArtifacts = exports.addLenderApprovalArtifacts = exports.createApprovalFlowRecords = void 0;
const lodash = __importStar(require("lodash"));
const uuid_1 = require("uuid");
const common_1 = require("@finley-technologies/common");
const dbNodes = __importStar(require("../dbNodes/dbNodes"));
const utils_1 = require("../dbNodes/utils");
const tape_builder_base_1 = require("../types/tape-builder-base");
const { cloneDeep, map } = lodash;
const generateNewSlug = (fundingRequestSlug, newPartialSlug) => {
    // fundingRequestSlug is guaranteed to be unique for the document
    // so we can just replace the fundingRequest with newPartialSlug
    // check if the slug already contains 'fundingrequest'
    // if it does, replace it with newPartialSlug
    // otherwise, append newPartialSlug to the end of the slug to ensure uniqueness.
    if (fundingRequestSlug.toLowerCase().includes('fundingrequest')) {
        return fundingRequestSlug.replace(/FundingRequest/gi, newPartialSlug);
    }
    return `${newPartialSlug}_${fundingRequestSlug}`;
};
//
const createApprovalFlowRecords = (fundingRequest) => {
    const { creditFacilitySlug, artifactDocumentId, artifactSlug: fundingRequestSlug, } = fundingRequest;
    const approvalReportSlug = generateNewSlug(fundingRequestSlug, 'ApprovalReport');
    const verificationReportSlug = generateNewSlug(fundingRequestSlug, 'VerificationReport');
    const userInputSlug = generateNewSlug(fundingRequestSlug, 'UserInputNeeded');
    const { lenderVerificationConfig } = fundingRequest.configuration;
    (0, common_1.finleyAssert)(lenderVerificationConfig, 'lenderVerificationConfig is missing');
    const { borrowingBaseReportArtifactSlug, borrowerNumbersArtifactSlug, borrowerEligibilityResultsArtifactSlugs, receivableResponseTapeArtifactSlug, } = lenderVerificationConfig;
    const verificationReport = {
        id: (0, uuid_1.v4)(),
        type: 'fundingVerificationReport',
        configuration: {
            borrowingBaseReportArtifactSlug,
            borrowerNumbersArtifactSlug,
            borrowerEligibilityResultsArtifactSlugs,
            receivableResponseTapeArtifactSlug,
        },
        loanProductSlug: null,
        creditFacilitySlug,
        artifactDocumentId,
        externalFilename: null,
        artifactSlug: verificationReportSlug,
    };
    const approvalReport = {
        id: (0, uuid_1.v4)(),
        type: 'fundingApprovalReport',
        configuration: {
            verificationReportSlug: (0, tape_builder_base_1.asArtifactSlugRef)(verificationReportSlug),
        },
        loanProductSlug: null,
        creditFacilitySlug,
        artifactDocumentId,
        externalFilename: null,
        artifactSlug: approvalReportSlug,
    };
    const userInputNode = {
        id: (0, uuid_1.v4)(),
        type: 'userInputNeeded',
        configuration: {
            inputType: 'verificationApproval',
        },
        loanProductSlug: null,
        creditFacilitySlug,
        artifactDocumentId,
        externalFilename: null,
        artifactSlug: userInputSlug,
    };
    return { approvalReport, verificationReport, userInputNode };
};
exports.createApprovalFlowRecords = createApprovalFlowRecords;
// addLenderApprovalArtifacts
// this function adds synthetic records for lender approval flow.
// it convert following graph:
// +----------------------+           +----------------------+
// |  BorrowingBaseReport +---------->|  FundingRequest      |
// +----------------------+           +----------------------+
//                                       ^       ^
// +----------------------+              |       |
// |  BorrowerNumbers     +--------------+       |
// +----------------------+                      |
//                                               |
// +----------------------------+                |
// | borrowerEligibilityResults +----------------+
// +----------------------------+
//
//
// +----------------------+         +----------------------+    +------------------+     +------------------+        +------------------+
// |  BorrowingBaseReport +-------->|  VerificationReport  +--->|  UserInputNeeded +---->|  ApprovalReport  +------->|  FundingRequest  |
// +----------------------+         +----------------------+    +------------------+     +------------------+        +------------------+
//                                       ^  ^      ^
// +----------------------+              |  |      |
// |  BorrowerNumbers     +--------------+  |      |
// +----------------------+                 |      |
//                                          |      |
// +-------------------------+              |      |
// | receivableResponseTape  +--------------+      |
// +-------------------------+                     |
//                                                 |
// +----------------------------+                  |
// | borrowerEligibilityResults +------------------+
// +----------------------------+
const addLenderApprovalArtifacts = (dbGraph) => {
    let dataTapeDependencies = cloneDeep(dbGraph.dataTapeDependencies);
    const dataTapes = cloneDeep(dbGraph.dataTapes);
    // check the generated FundingRequest artifact
    const fundingRequests = (0, utils_1.filterFundingRequests)({ dataTapes });
    fundingRequests.forEach((fundingRequest) => {
        // if the config for the funding Request has lenderVerificationConfig then
        // we need to create synthetic records for approval flow.
        // if not, then we can skip this step
        (0, common_1.finleyAssert)(dbNodes.fundingRequest.hasArtifactType(fundingRequest), `not a funding request`);
        const { lenderVerificationConfig } = fundingRequest.configuration;
        if (!lenderVerificationConfig) {
            return; // no-op if there is no lenderVerificationConfig
        }
        // create and add new synthetic nodes to the graph
        const { verificationReport, approvalReport, userInputNode, } = (0, exports.createApprovalFlowRecords)(fundingRequest);
        // we expect two input artifacts (BBR => FundingRequest, BorrowerNumbers => FundingRequest)
        const inputSlugs = (0, utils_1.getInputTapes)({
            dbGraph: {
                dataTapes,
                dataTapeDependencies,
            },
            outputArtifactId: fundingRequest.id,
        }).map(({ artifactSlug }) => artifactSlug);
        const borrowerEligibilityResultsArtifactInputSlugs = map(lenderVerificationConfig.borrowerEligibilityResultsArtifactSlugs, (slug) => slug);
        // ensure that inputSlugs match fundingRequest configuration
        const expectedInputSlugs = [
            lenderVerificationConfig.borrowingBaseReportArtifactSlug,
            lenderVerificationConfig.borrowerNumbersArtifactSlug,
            ...borrowerEligibilityResultsArtifactInputSlugs,
        ];
        (0, common_1.finleyAssert)(inputSlugs.length === expectedInputSlugs.length, `expected ${expectedInputSlugs.length} input tapes for funding request. Found[${inputSlugs.length}]`);
        expectedInputSlugs.forEach((expectedInputSlug) => {
            (0, common_1.finleyAssert)(inputSlugs.includes(expectedInputSlug), `expected input tapes to include[${expectedInputSlug}]`);
        });
        // find dependencies with funding request as output.
        const fundingRequestDependencies = (0, utils_1.getDependenciesByOutputId)({
            dataTapeDependencies,
            outputArtifactId: fundingRequest.id,
        });
        // replace those dependencies to be VerificationReport as the target
        // instead of FundingRequest
        const verificationReportDependencies = fundingRequestDependencies.map(({ inputArtifactId }) => {
            return {
                inputArtifactId,
                outputArtifactId: verificationReport.id,
            };
        });
        // find reveivable response tape
        const receivableResponseTape = (0, utils_1.findArtifactBySlug)({
            dataTapes,
            artifactSlug: lenderVerificationConfig.receivableResponseTapeArtifactSlug,
        });
        // add receivable response tape as dependency to verification report
        verificationReportDependencies.push({
            inputArtifactId: receivableResponseTape.id,
            outputArtifactId: verificationReport.id,
        });
        // remove the old dependencies
        dataTapeDependencies = (0, utils_1.removeDependencies)({
            dataTapeDependencies,
            dependenciesToRemove: fundingRequestDependencies,
        });
        // reaplce existing dependencies with new dependencies
        dataTapeDependencies.push(...verificationReportDependencies);
        // + verificationReport => userInputNode
        dataTapeDependencies.push({
            inputArtifactId: verificationReport.id,
            outputArtifactId: userInputNode.id,
        });
        // + userInputNode => approvalReport
        dataTapeDependencies.push({
            inputArtifactId: userInputNode.id,
            outputArtifactId: approvalReport.id,
        });
        // + aprovalReport => fundingRequest
        dataTapeDependencies.push({
            inputArtifactId: approvalReport.id,
            outputArtifactId: fundingRequest.id,
        });
        // add new dataTapes.
        dataTapes.push(userInputNode, approvalReport, verificationReport);
    });
    return { dataTapeDependencies, dataTapes };
};
exports.addLenderApprovalArtifacts = addLenderApprovalArtifacts;
const removeLenderApprovalArtifacts = (dbGraph) => {
    let dataTapeDependencies = cloneDeep(dbGraph.dataTapeDependencies);
    let dataTapes = cloneDeep(dbGraph.dataTapes);
    const approvalReports = (0, utils_1.filterApprovalReports)({ dataTapes });
    approvalReports.forEach((approvalReport) => {
        // VerificationReport  +--->|  UserInputNeeded +---->|  ApprovalReport  +------->|  FundingRequest
        const approvalReportOutputs = (0, utils_1.getOutputTapes)({
            inputArtifactId: approvalReport.id,
            dbGraph,
        });
        (0, common_1.finleyAssert)(approvalReportOutputs.length === 1, `expected only one output dependency for approval report, found[${approvalReportOutputs.length}]`);
        const fundingRequest = approvalReportOutputs[0];
        (0, common_1.finleyAssert)(dbNodes.fundingRequest.hasArtifactType(fundingRequest), `not a funding request`);
        const approvalReportInputs = (0, utils_1.getInputTapes)({
            dbGraph,
            outputArtifactId: approvalReport.id,
        });
        (0, common_1.finleyAssert)(approvalReportInputs.length === 1, 'expected one input tape');
        const userInputNode = approvalReportInputs[0];
        (0, common_1.finleyAssert)(userInputNode.type === 'userInputNeeded', 'not a userInputNode');
        // approvalReport verificationReportSlug in its configuration.
        const verificationReport = dataTapes.find((dataTape) => {
            return (dataTape.artifactSlug ===
                approvalReport.configuration.verificationReportSlug);
        });
        (0, common_1.finleyAssert)(verificationReport, `verification report not found. For [approvalReportSlug: ${approvalReport.artifactSlug}], [verificationReportSlug:${approvalReport.configuration.verificationReportSlug}]`);
        // find dependencies with funding request as output.
        const verificationReportDependencies = (0, utils_1.getDependenciesByOutputId)({
            dataTapeDependencies,
            outputArtifactId: verificationReport.id,
        });
        const allDependencyInputTapes = (0, utils_1.getAllDependencyInputTapes)({
            outputArtifactId: verificationReport.id,
            dbGraph,
        });
        const uniqueLoanProductSlugs = new Set();
        allDependencyInputTapes.forEach((dataTape) => {
            if (dataTape.loanProductSlug) {
                uniqueLoanProductSlugs.add(dataTape.loanProductSlug);
            }
        });
        // we expect at least four edges:
        // 1) ReceivableResponseTape => FundingRequest,
        // 2) Borrowing base report => FundingRequest,
        // 3) BorrowerNumbers => FundingRequest
        // 4-x) BorrowerEligibilityResults => FundingRequest (at least 1, 1 for each loan product),
        const expectedNumberOfDependencies = 3 + uniqueLoanProductSlugs.size;
        (0, common_1.finleyAssert)(verificationReportDependencies.length === expectedNumberOfDependencies, `expected ${expectedNumberOfDependencies} input dependencies for verificationReport. Found[${verificationReportDependencies.length}]`);
        // replace those dependencies to be FundingRequest as the target
        // instead of VerificationReport (and remove ReceivableResponseTape)
        const fundingRequestDependencies = verificationReportDependencies
            .filter(({ inputArtifactId }) => {
            // we do not want to include the ReceivableResponseTape
            // as dependency in fundingRequestDependencies.
            const inputTape = (0, utils_1.findArtifactById)({
                dataTapes,
                artifactId: inputArtifactId,
            });
            return inputTape.type !== 'receivableResponseTape';
        })
            .map(({ inputArtifactId }) => {
            return {
                inputArtifactId,
                outputArtifactId: fundingRequest.id,
            };
        });
        const dependenciesToRemove = [...verificationReportDependencies];
        // - verificationReport => userInputNode
        dependenciesToRemove.push({
            inputArtifactId: verificationReport.id,
            outputArtifactId: userInputNode.id,
        });
        // - userInputNode => approvalReport
        dependenciesToRemove.push({
            inputArtifactId: userInputNode.id,
            outputArtifactId: approvalReport.id,
        });
        // - aprovalReport => fundingRequest
        dependenciesToRemove.push({
            inputArtifactId: approvalReport.id,
            outputArtifactId: fundingRequest.id,
        });
        dataTapeDependencies = (0, utils_1.removeDependencies)({
            dataTapeDependencies,
            dependenciesToRemove,
        });
        dataTapeDependencies.push(...fundingRequestDependencies);
        // remove approval report and verification report from dataTapes
        const idsToRemove = [
            approvalReport.id,
            verificationReport.id,
            userInputNode.id,
        ];
        dataTapes = dataTapes.filter(({ id }) => !idsToRemove.includes(id));
    });
    return { dataTapeDependencies, dataTapes };
};
exports.removeLenderApprovalArtifacts = removeLenderApprovalArtifacts;
exports.syntheticProcess = {
    toDb: exports.addLenderApprovalArtifacts,
    fromDb: exports.removeLenderApprovalArtifacts,
};
//# sourceMappingURL=lenderApprovalFlow.js.map